import { h } from "preact";
import styled from "styled-components";

import { shuffle } from "utils/shuffle";
import { lawyers } from "utils/lawyers";

import Thumbnail from "components/Thumbnail";
import ThumbnailWrapper from "components/Thumbnail/ThumbnailWrapper";
import ThumbnailDiv from "components/Thumbnail/ThumbnailDiv";
import ThumbnailNumber from "components/Thumbnail/ThumbnailNumber";

const ThumbnailNumberSmall = styled(ThumbnailNumber)`
  border: none;
  width: ${props => props.size};
  height: ${props => props.size};
  font-size: 16px;
  padding: 0;
  padding-bottom: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ThumbnailDivSmall = styled(ThumbnailDiv)`
  margin-left: -8px;
`

const LawyerImages = (props) => {
  const size = props.size && props.size === 'sm' ? '27px' : '48px';
  return (
    <ThumbnailWrapper data-testid="summary-lawyer-thumbnail">
      {shuffle(lawyers)
        .slice(0, 3)
        .map((lawyer, index) => (
          <ThumbnailDivSmall size={size} key={"lawyer" + index} zIndex={10 - index}>
            <Thumbnail
              src={lawyer}
              alt={"lawyer " + index}
              style={{ borderWidth: "2px", width: size, height: size }}
            />
          </ThumbnailDivSmall>
        ))}
      <ThumbnailDivSmall size={size} zIndex={6}>
        <ThumbnailNumberSmall size={size}>
          30<span style={{ marginBottom: '3px' }}>+</span>
        </ThumbnailNumberSmall>
      </ThumbnailDivSmall>
    </ThumbnailWrapper>
  );
};

export default LawyerImages;
